import { render, staticRenderFns } from "./TopLosers.vue?vue&type=template&id=1ae89f48"
import script from "./TopLosers.vue?vue&type=script&lang=js"
export * from "./TopLosers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports